import { API_ROUTES } from '@config/routes';
import api from './api';

export const emailService = {
  sendEmail: async (data: {
    to: string;
    subject: string;
    html: string;
    text: string;
    conversationId?: string;
  }) => {
    return api.post(API_ROUTES.EMAIL.SEND, data);
  },

  scheduleEmail: async (data: {
    to: string;
    subject: string;
    html: string;
    text: string;
    conversationId?: string;
    scheduledAt: string; // ISO string
  }) => {
    return api.post(API_ROUTES.EMAIL.SCHEDULE, data);
  },

  verifySettings: async (emailSettings: Record<string, unknown>) => {
    return api.post(API_ROUTES.EMAIL.VERIFY, { emailSettings });
  },

  fetchEmails: async () => {
    return api.get(API_ROUTES.EMAIL.FETCH);
  },

  syncEmails: async (): Promise<{ addedCount: number }> => {
    return api.post<{ addedCount: number }>(API_ROUTES.EMAIL.SYNC);
  },

  getScheduledEmails: async () => {
    return api.get<{
      success: boolean;
      data: Array<{
        id: string;
        to: string;
        subject: string;
        scheduledAt: string;
        createdAt: string;
        updatedAt?: string;
        projectId?: string;
      }>;
    }>(API_ROUTES.EMAIL.SCHEDULED_LIST);
  },

  cancelScheduledEmail: async (id: string) => {
    return api.delete(API_ROUTES.EMAIL.SCHEDULED_DELETE(id));
  },

  updateScheduledEmail: async (
    id: string,
    data: { subject?: string; html?: string; text?: string; scheduledAt?: string }
  ) => {
    return api.patch(`/email/scheduled/${id}`, data);
  },
};
